import { MasterConfigContext } from "@/context/MasterConfigContext";
import { usePathname } from "next/navigation";
import { useContext, useEffect } from "react";

const IPLMenu = () => {
  const pathname = usePathname();
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];
  useEffect(() => {
    document.getElementById(pathname + "_1")?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
    if (pathname?.includes('orange-cap')) {
      document.getElementById("/sports/ipl/orange-cap_1")?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
    if (pathname?.includes('purple-cap')) {
      document.getElementById("/sports/ipl/purple-cap_1")?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [pathname]);

  // Mapping menu items to their respective routes
  const menuItems = [
    { name: "Home", path: "/sports/ipl" },
    ...(iplKeys?.showPointsTableTab
      ? [{ name: "Point Table", path: "/sports/ipl/points-table" }]
      : []),
    ...(iplKeys?.showScheduleTab
      ? [{ name: "Schedule", path: "/sports/ipl/schedule" }]
      : []),
    ...(iplKeys?.showMatchesTab
      ? [{ name: "Matches", path: "/sports/ipl/live" }]
      : []),
    ...(iplKeys?.showStatsTab
      ? [{ name: "Stats", path: "/sports/ipl/stats" }]
      : []),
    ...(iplKeys?.showPurpleCap
      ? [{ name: "Purple Cap", path: "/sports/ipl/purple-cap" }]
      : []),
    ...(iplKeys?.showOrangeCap
      ? [{ name: "Orange Cap", path: "/sports/ipl/orange-cap" }]
      : []),
  ];

  return (
    <div className="flex items-center bg-[#F8F9FB] shadow-md p-3">
      {/* Logo */}
      <img
        src="https://akm-img-a-in.tosshub.com/lingo/nwtak/resources/t20-02.png"
        alt="IPL Logo"
        className="hidden md:block w-20 h-auto mr-4"
      />

      {/* Scrollable Navigation */}
      <div
        className="overflow-x-auto scrollbar-hide whitespace-nowrap"
        style={{ scrollbarWidth: "none" }}
      >
        <div className="flex space-x-2">
          {menuItems.map((item) => (
            <a
              key={item.name}
              id={item.path + "_1"}
              href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${item.path}`}
              className={`py-1 md:py-2 px-4 rounded-lg text-sm ${
                (item.path === "/sports/ipl"
                  ? pathname === "/sports/ipl"
                  : pathname?.startsWith(item.path)) ||
                (item.name === "Matches" &&
                  ["/sports/ipl/recent", "/sports/ipl/upcoming"].includes(
                    pathname
                  )) ||
                (item.name === "Orange Cap" &&
                  pathname?.includes("orange-cap-winner")) ||
                (item.name === "Purple Cap" &&
                  pathname?.includes("purple-cap-winner"))
                  ? "bg-primary text-white border-2 border-primary"
                  : "border-2 text-gray-600 hover:text-primary"
              }`}
              target={"_self"}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IPLMenu;
